const doc = [({"da":({"js":({"layout":({"impersonation_banner":({"back_to_admin":"Tilbage til admin", "signed_in_as":"Du er logget ind som %{name} via admin."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;